import * as React from "react"

import { cn } from "@/utils/utils"
import { styleDrivers } from "@/utils/componentStyle"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(styleDrivers.input.root, className)}
      {...props}
    />
  )
}

export { Input }
